/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddAssetTypeSubsystemMappingRequestDto
 */
export interface AddAssetTypeSubsystemMappingRequestDto {
    /**
     * ID of the asset type
     * @type {string}
     * @memberof AddAssetTypeSubsystemMappingRequestDto
     */
    assetTypeId: string;
    /**
     * ID of the subsystem
     * @type {string}
     * @memberof AddAssetTypeSubsystemMappingRequestDto
     */
    subsystemId: string;
}

/**
 * Check if a given object implements the AddAssetTypeSubsystemMappingRequestDto interface.
 */
export function instanceOfAddAssetTypeSubsystemMappingRequestDto(value: object): value is AddAssetTypeSubsystemMappingRequestDto {
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    if (!('subsystemId' in value) || value['subsystemId'] === undefined) return false;
    return true;
}

export function AddAssetTypeSubsystemMappingRequestDtoFromJSON(json: any): AddAssetTypeSubsystemMappingRequestDto {
    return AddAssetTypeSubsystemMappingRequestDtoFromJSONTyped(json, false);
}

export function AddAssetTypeSubsystemMappingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddAssetTypeSubsystemMappingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetTypeId': json['assetTypeId'],
        'subsystemId': json['subsystemId'],
    };
}

export function AddAssetTypeSubsystemMappingRequestDtoToJSON(json: any): AddAssetTypeSubsystemMappingRequestDto {
    return AddAssetTypeSubsystemMappingRequestDtoToJSONTyped(json, false);
}

export function AddAssetTypeSubsystemMappingRequestDtoToJSONTyped(value?: AddAssetTypeSubsystemMappingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetTypeId': value['assetTypeId'],
        'subsystemId': value['subsystemId'],
    };
}

